

export default (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/esm/view/window/get-window-scroll.js
// module id = 406
// module chunks = 0